import { SET_LINKEDIN_INDUSTRIES } from '../actions/actions';
import produce from 'immer';

const INITIAL_STATE = {
  linkedinIndustries: []
};

export default function linkedinIndustriesReducer(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_LINKEDIN_INDUSTRIES: {
        draft.linkedinIndustries = action.payload;
        break;
      }
      default:
        return state;
    }
  });
}
